// Notification
// ============

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import style from './index.scss'

import { ReactComponent as Tick } from './tick.inline.svg'
import { ReactComponent as Alert } from './alert.inline.svg'

const Notification = ({ type, message, onClickDismiss, className }) => {
  return (
    <div className={cx(style.Notification, style[type], className)}>
      <header className={style.header}>
        {type === 'success' ? (
          <Tick className={cx(style.icon, style[type])} />
        ) : (
          <Alert className={cx(style.icon, style[type])} />
        )}
        <span className={style.message}>{message}</span>

        {onClickDismiss && (
          <button
            aria-label="Dismiss"
            onClick={onClickDismiss}
            className={style.dismiss}
          >
            <svg
              className={style[type]}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path fill="none" d="M13 13L1 1m12 0L1 13" />
            </svg>
          </button>
        )}
      </header>
    </div>
  )
}

Notification.propTypes = {
  type: PropTypes.oneOf(['success', 'info', 'failure']),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClickDismiss: PropTypes.func,
  className: PropTypes.string,
}

export default Notification
